// services/everpro/everpro-shipping/logistics.ts â€” daftar kurir Everpro per-brand via S2 proxy
import { everproLogisticsCache } from './cache.js';

import { everproFetch } from '../everpro-auth';
import type { EverproLogistic } from '../everpro-types';
import { validatePostalCode } from '../everpro-location';

export async function fetchLogistics(brandId: string): Promise<EverproLogistic[]> {
  if (!brandId) throw new Error('Everpro: brandId wajib');
  if (everproLogisticsCache.value && everproLogisticsCache.brandId === brandId) return everproLogisticsCache.value;

  const res = await everproFetch(brandId, '/shipment/v1/logistics');
  if (!res.ok) throw new Error(`fetchLogistics failed: ${res.status}`);
  const json = await res.json();
  const logistics = (json?.data?.logistics ?? []) as EverproLogistic[];
  everproLogisticsCache.value = logistics;
  everproLogisticsCache.brandId = brandId;
  return logistics;
}

export function clearLogisticsCache(): void {
  everproLogisticsCache.value = null;
  everproLogisticsCache.brandId = '';
}

export function prewarmEverpro(brandId: string, originPostalCode?: string): void {
  if (!brandId) return;
  fetchLogistics(brandId).catch(() => {});
  if (originPostalCode) validatePostalCode(originPostalCode, brandId).catch(() => {});
}
